import { createApp } from 'vue';
import App from './App.vue';
import PrimeVue from 'primevue/config';

// Эти пути существуют только в v3 — теперь они не выдадут ошибку
import "primevue/resources/themes/lara-light-indigo/theme.css"; 
import "primevue/resources/primevue.min.css";           
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import Dropdown from 'primevue/dropdown';
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';
import Button from 'primevue/button';

const app = createApp(App);
app.use(PrimeVue, {
    locale: {
        dayNamesShort: ['Вс.', 'Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.'],
        dayNamesMin: ['Вс.', 'Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.'],
        monthNames: ["Янв.", "Фев.", "Мар.", "Апр.", "Май", "Июнь", "Июль", "Авг.", "Сен.", "Окт.", "Ноя.", "Дек." ],
        monthNamesShort: ["Янв.", "Фев.", "Мар.", "Апр.", "Май", "Июнь", "Июль", "Авг.", "Сен.", "Окт.", "Ноя.", "Дек." ],
        firstDayOfWeek: 1,
        dateFormat: "dd.mm.yy",
        invalidFileTypeMessage: 'Недопустимый тип файла. Разрешенные типы: {0}',
        invalidFileSizeMessage: 'Недопустимый размер файла. Максимальный размер: {0}',
        emptyMessage: "Нет значений"
    }
});
app.component('Dropdown', Dropdown);
app.component('BlockUI', BlockUI);
app.component('ProgressSpinner', ProgressSpinner);
app.component('Button', Button);

app.mount('#app');